import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import { subscribe, unsubscribe} from '_ui-core-js/utilities/events.js';
import { VALUES_MAP } from './valuesMap.js';
import { Toolbar } from './Toolbar/Toolbar.jsx';

export function VehicleConfigurator({configuratorData, imageProps, modelName, onChangeCallback, baseModelName}) {
  const block = 'c-vehicle-configurator';
  const [activeSelections, setActiveSelections] = useState(configuratorData.activeSelections);
  // const [image, setImage] = useState(imageProps); - TODO - handle state locally for independent use

  function getNewMultiSelectActiveItems(index, activeItemsArray) {
    const selectedItemArrayIndex = activeItemsArray.indexOf(index);
    if (selectedItemArrayIndex > -1) { // deactivate item
      const newArray = activeItemsArray.slice(0); // clone array
      newArray.splice(selectedItemArrayIndex, 1); // remove item
      return newArray;
    } else { //activate item
      return [...activeItemsArray, index];
    }
  };
  
  function update(event) {
    const { option, index, multiSelect } = event.detail;
    const newOptionData = configuratorData.options[option][index];
    const newOptionCode = newOptionData.code || newOptionData.short;
    const newActiveSelectionsObj = Object.assign({}, configuratorData.activeSelections, { [option]: !multiSelect ? index : getNewMultiSelectActiveItems(index, configuratorData.activeSelections[option])});
    let newImageProps = Object.assign({}, imageProps, { [VALUES_MAP.OPTIONS[option][0]]: newOptionCode});

    // If changing wheels we need to determine whether they are an option or accessory
    if(VALUES_MAP.OPTIONS[option][0] === VALUES_MAP.OPTIONS.wheels[0]) {
      newImageProps = Object.assign({}, newImageProps, { wheelType: newOptionData.type });
    } 

    if (!onChangeCallback) {
      // Use component state if configurator is being used in isolation.
      setActiveSelections(newActiveSelectionsObj);
    } else {
      // Use callback to get updated data outside of this component
      onChangeCallback(newImageProps, newActiveSelectionsObj);
    }
  };

  useEffect(() => {
    subscribe('kc-vehicle-configurator-update', update);
    return () => {
      unsubscribe('kc-vehicle-configurator-update', update);
    }
  }, [configuratorData.activeSelections]);

  return(
    <div className={`${block} col-12 col-xxl-10`}>
      {/* If this component is used elsewhere outside range selector we will need to do some work to maintain state at this level */}
      {/* <LazyCCISImage { ...imagePropsRef.current } /> */}
      {/* <Toolbar {...Object.assign({}, configuratorData. activeSelections} imageProps={imageProps} /> */}
      <Toolbar {...configuratorData} imageProps={imageProps} modelName={modelName} baseModelName={baseModelName}/>
    </div> 
  )
};

VehicleConfigurator.propTypes = {
  configuratorData: propTypes.object.isRequired,
  imageProps: propTypes.object.isRequired,
  onChangeCallback: propTypes.func,
  modelName: propTypes.string,
  baseModelName: propTypes.string,
};